import React from "react";
import { cleanDate } from "../../../../util/app";
import AddButton from "../../../../partials/Buttons/AddButton";

/**
 * @param {any} item object containing  room search item
 */
function DrugChartDetail({ item, onIntake }) {
    return (
        <div className="row justify-content-center">
            {item.prescriptions.map((i, idx) => (
                <div className="row" key={idx}>
                    <div className="col-4 bg-primary">
                        <h5>DRUG {idx + 1}</h5>
                    </div>
                    <div className="col-12">
                        <table className="table table-bordered table-hover">
                            <tbody>
                                <tr>
                                    <td style={{ width: "40%" }}>
                                        <strong className="uppercase">Drug Name</strong>
                                    </td>
                                    <td style={{ width: "60%" }}>{i.drugName}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%" }}>
                                        <strong className="uppercase">Dose</strong>
                                    </td>
                                    <td style={{ width: "60%" }}>{i.dose}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%" }}>
                                        <strong className="uppercase">route</strong>
                                    </td>
                                    <td style={{ width: "60%" }}>{i.route}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%" }}>
                                        <strong className="uppercase">Frequency</strong>
                                    </td>
                                    <td style={{ width: "60%" }}>{i.frequency}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%" }}>
                                        <strong className="uppercase">Instruction</strong>
                                    </td>
                                    <td style={{ width: "60%" }}>{i.instruction}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%" }}>
                                        <strong className="uppercase">pharmacy</strong>
                                    </td>
                                    <td style={{ width: "60%" }}>{i.pharmacy}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%" }}>
                                        <strong className="uppercase">duration</strong>
                                    </td>
                                    <td style={{ width: "60%" }}>
                                        {cleanDate(i.startDate, true)} <i className="material-icons text-primary">trending_flat</i> {cleanDate(i.stopDate, true)}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "40%" }}>
                                        <strong className="uppercase">intakes</strong>
                                    </td>
                                    <td style={{ width: "60%" }}>
                                        {i.intakes.length < 1 && <span className="text-primary">No intake has been recorded yet!</span>}
                                        {i.intakes.map((intake, index) => (
                                            <React.Fragment key={index}>
                                                <div className="col-4 bg-primary">
                                                    <h5> InTake No {index + 1}</h5>
                                                </div>
                                                <table className="table table-bordered">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: "40%" }}>
                                                                <strong>DOSE</strong>
                                                            </td>
                                                            <td style={{ width: "60%" }}> {intake.dose}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "40%" }}>
                                                                <strong>INITIAL</strong>
                                                            </td>
                                                            <td style={{ width: "60%" }}> {intake.initial}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "40%" }}>
                                                                <strong>NOTE</strong>
                                                            </td>
                                                            <td style={{ width: "60%" }}> {intake.note}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "40%" }}>
                                                                <strong>DATE & TIME</strong>
                                                            </td>
                                                            <td style={{ width: "60%" }}> {cleanDate(intake.datetime, true)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </React.Fragment>
                                        ))}
                                        <div className="text-right">
                                            <AddButton title="Add Intake" onClick={() => onIntake({ id: item.id, prescriptionId: i.prescriptionId })} />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default DrugChartDetail;
